import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styled from '@emotion/styled';

const Svg = styled('svg')(props => ({
    ...props.style,
    path: {
        transition: 'all 0.2s ease-in-out'
    }
}));

export class Logo extends PureComponent {
    static propTypes = {
        styles: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        markColor: PropTypes.string,
        color: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
        small: PropTypes.bool,
        height: PropTypes.number,
        link: PropTypes.string,
        width: PropTypes.number
    };

    static defaultProps = {
        styles: {},
        color: '#FFFFFF',
        small: false,
        height: undefined,
        link: undefined,
        width: undefined,
        markColor: undefined
    };

    render() {
        const { color, styles, small, height: hOverride, width: wOVerride, link, markColor } = this.props;
        const width = wOVerride || (small ? '93px' : '379px');
        const height = hOverride || (small ? '27px' : '108px');
        const logoMark = (
            <Svg
                width={width}
                height={height}
                viewBox="0 0 379 108"
                fill="none"
                styles={styles}
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M95.2911 72.206C95.2928 78.1681 92.0936 83.678 86.8995 86.6603L57.2129 103.7C52.0188 106.682 45.6194 106.683 40.4244 103.703L10.7335 86.6707C5.53937 83.6901 2.33838 78.1819 2.3375 72.2207L2.33228 38.1453C2.33228 32.1841 5.53066 26.6759 10.7248 23.6962L43.3404 4.97936C50.7542 0.725453 60.02 6.05432 60.0025 14.563L59.9171 56.1571C59.9102 59.4833 58.1236 62.5548 55.2268 64.2197L33.0795 76.9537C27.291 80.2816 20.048 76.1308 20.0463 69.4844L20.0384 47.4881C20.0367 42.0319 22.964 36.9889 27.718 34.2595L60.9298 15.191C68.3366 10.938 77.5971 16.2521 77.5945 24.7538L77.5815 62.8632C77.5797 68.3125 74.6567 73.3477 69.9106 76.0771L50.763 87.0873C44.9736 90.4161 37.7306 86.2645 37.7289 79.6172L37.7245 54.209C37.7237 50.8724 39.5146 47.7896 42.421 46.1213L78.636 25.3377C86.0419 21.0872 95.2998 26.4014 95.2981 34.9014L95.2911 72.206Z"
                    stroke={markColor || 'url(#paint0_linear_382_2)'}
                    strokeWidth={small ? 4 : 3}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M347.631 25.125C357.973 24.8474 374.706 29.4925 376.852 50.5198C377.779 59.6067 378.283 70.3876 378.363 82.8625H365.283V76.9792C359.92 81.978 354.152 84.4764 347.979 84.4764C340.185 84.4764 333.742 81.6698 328.649 76.0556C323.595 70.3264 321.067 63.1744 321.067 54.5996C321.067 46.1788 323.595 39.1603 328.649 33.5462C333.704 27.933 340.033 25.329 347.631 25.125ZM348.593 38.9179C339.769 38.9179 333.631 46.0469 333.631 54.841C333.631 63.635 339.769 70.7641 348.593 70.7641C357.416 70.7641 363.711 63.635 363.711 54.841C363.711 46.0469 357.416 38.9179 348.593 38.9179Z"
                    fill={color}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M153.53 25.125C163.871 24.8474 180.604 29.4925 182.75 50.5198C183.677 59.6067 184.181 70.3876 184.261 82.8625H171.182V76.9792C165.818 81.978 160.05 84.4764 153.877 84.4764C146.083 84.4764 139.64 81.6698 134.547 76.0556C129.493 70.3264 126.966 63.1744 126.966 54.5996C126.966 46.1788 129.493 39.1603 134.547 33.5462C139.602 27.933 145.932 25.329 153.53 25.125ZM154.491 38.9179C145.667 38.9179 139.53 46.0469 139.53 54.841C139.53 63.635 145.667 70.7641 154.491 70.7641C163.315 70.7641 169.609 63.635 169.609 54.841C169.609 46.0469 163.315 38.9179 154.491 38.9179Z"
                    fill={markColor || 'url(#paint1_linear_382_2)'}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M196.04 82.8625H209.061V26.6828H196.04V82.8625ZM194.072 10.6857C194.072 8.41745 194.901 6.45635 196.56 4.8024C198.219 3.14846 200.206 2.32251 202.521 2.32251C204.874 2.32251 206.88 3.14846 208.541 4.8024C210.199 6.41731 211.029 8.39793 211.029 10.7432C211.029 13.0896 210.199 15.0887 208.541 16.7416C206.921 18.3956 204.933 19.2225 202.58 19.2225C200.226 19.2225 198.219 18.3956 196.56 16.7416C194.901 15.0887 194.072 13.0701 194.072 10.6857Z"
                    fill={markColor || 'url(#paint2_linear_382_2)'}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M260.028 47.2164C258.214 40.2956 253.835 36.8346 246.891 36.8346C245.309 36.8346 243.822 37.075 242.435 37.5558C241.046 38.0355 239.781 38.7279 238.644 39.6319C237.505 40.5359 236.531 41.6218 235.721 42.8905C234.91 44.1592 234.293 45.6015 233.868 47.2164H260.028ZM273.397 57.8294H233C233.348 62.444 234.853 66.1156 237.515 68.8462C240.177 71.5377 243.592 72.8834 247.759 72.8834C251 72.8834 253.682 72.115 255.803 70.5761C257.476 69.3414 259.335 67.2638 261.381 64.3437C261.506 64.1649 265.685 65.4349 273.918 68.1538C272.22 71.0374 270.426 73.509 268.535 75.5657C266.645 77.6234 264.619 79.3153 262.458 80.6416C260.298 81.9678 257.964 82.9386 255.456 83.555C252.948 84.1693 250.228 84.4775 247.295 84.4775C238.884 84.4775 232.133 81.7849 227.039 76.4019C221.947 70.9798 219.4 63.7898 219.4 54.8308C219.4 45.9477 221.869 38.7567 226.808 33.2586C231.786 27.8365 238.383 25.1255 246.601 25.1255C254.896 25.1255 261.456 27.7595 266.278 33.0274C271.063 38.2574 273.454 45.505 273.454 54.7722L273.397 57.8294Z"
                    fill={color}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M284.318 26.6831H297.339V31.7014C302.391 25.1257 313.98 22.6366 322.545 28.977L314.985 39.3856C305.681 34.2871 297.339 38.6254 297.339 53.7348V82.8628H284.318V26.6831Z"
                    fill={color}
                />
                <defs>
                    <linearGradient
                        id="paint0_linear_382_2"
                        x1="18.2868"
                        y1="6.61397"
                        x2="82.6058"
                        y2="102.63"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#FF5001" />
                        <stop offset="1" stopColor="#FF0099" />
                    </linearGradient>
                    <linearGradient
                        id="paint1_linear_382_2"
                        x1="155.613"
                        y1="25.1135"
                        x2="155.613"
                        y2="84.4764"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#FF5001" />
                        <stop offset="1" stopColor="#FF0099" />
                    </linearGradient>
                    <linearGradient
                        id="paint2_linear_382_2"
                        x1="202.551"
                        y1="2.32251"
                        x2="202.551"
                        y2="82.8625"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#FF5001" />
                        <stop offset="1" stopColor="#FF0099" />
                    </linearGradient>
                </defs>
            </Svg>
        );

        if (link) {
            return <Link to={link}>{logoMark}</Link>;
        }

        return logoMark;
    }
}
